import { apiService } from './apiService';

export const decisionMatrixService = {
  async get() { return apiService.get('/decision-matrix'); },
  async save(headers: string[], rows: unknown[][]) { return apiService.put('/decision-matrix', { headers, rows }); },
};
